import { render, staticRenderFns } from "./customer-data.vue?vue&type=template&id=20d2589a"
import script from "./customer-data.vue?vue&type=script&lang=js"
export * from "./customer-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports